import { Auth } from "mise-react-redux-auth0-2";

const Auth0 = new Auth({
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  clientID: import.meta.env.VITE_AUTH0_CLIENTID,
  audience: import.meta.env.VITE_AUTH0_APIAUDIENCE,
  redirectUri: import.meta.env.VITE_AUTH0_CALLBACKURL,
  returnTo: import.meta.env.VITE_SIGNOUT_RETURNURL,
  scope: 'openid profile email update:password deliveries:send-to-customer deliveries:receive-from-customer deliveries:upload-files deliveries:send-from-customer',
  responseType: 'token id_token',
  _disableDeprecationWarnings: true // Add this to suppress auth0-js warnings
});

export default Auth0;